import React from 'react';
import { EmptyState } from './EmptyState';
import { gettext } from '@eb/i18n-ebspa';
import { NoResultsIllustration as NoResultsIllustrationSvg } from '@eb/eds-iconography';

export const NoResults = (props) => (
    <EmptyState illustrationType={<NoResultsIllustrationSvg />} {...props}>
        {gettext(
            'Nothing matched your search, but you might like these options.',
        )}
    </EmptyState>
);
